import { render, staticRenderFns } from "./PropertyBrowser.yaml?vue&type=template&id=d351c126&component"
import script from "./PropertyBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./PropertyBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports